import { ECallActive } from '../../actions/call/types';
import { ICall } from '../../types/call';
import { TReduxActions } from '../../types/redux';

const defaultState: ICall = {
  callActive: false,
};

export function callReducer(state: ICall = defaultState, action: TReduxActions): ICall {
  switch (action.type) {
    case ECallActive.SetCallActive:
      return {
        ...state,
        callActive: true,
      };
    case ECallActive.ClearCallActive:
      return {
        ...state,
        callActive: false,
      };
    default:
      return defaultState;
  }
}
